import { FlexView, Separator, Col } from '@cuemath/comps';
import React from 'react';
import MappingFilters from './components/mapping-filters';
import AvailableDates from './components/available-dates';
import useLogic from './AcLedMapping.logic';
import { Text } from '@cuemath/web-comps';
import HourlyTimeslots from './components/hourly-time-slots';
import BallLoader from 'comps/ball-loader';
import styled from 'styled-components';
import { MAPPING_FILTERS_CONFIG_KEY } from 'constants/ac-led-mapping';

const LoaderWrapper = styled(FlexView)`
  width: 100%;
  height: 100%;
  flex: 1;
`;

const AcLedMapping = () => {
  const {
    selectedDate,
    dateOptions,
    handleSelectDate,
    handleSelectCustomDate,
    customDate,
    handleSearchTeachers,
    handleFilterChange,
    filters,
    isSearchProcessing,
    timeWindows,
    isTimeSlotAvailable,
    activeDate,
  } = useLogic();

  const empty = isSearchProcessing ? (
    <LoaderWrapper alignItems="center" justifyContent="center">
      <BallLoader />
    </LoaderWrapper>
  ) : (
    <Col alignItems="center" justifyContent="center" inherit>
      <Text variant="h4" align="center">
        No slots found!
      </Text>
    </Col>
  );

  return (
    <FlexView gap={24} gutter={16}>
      <MappingFilters
        filters={filters}
        handleChange={handleFilterChange}
        handleSearchTeachers={handleSearchTeachers}
        isSearchProcessing={isSearchProcessing}
        configKey={MAPPING_FILTERS_CONFIG_KEY}
      />
      <Separator height={24} transparent />
      <Separator height={1} />
      <Separator height={12} transparent />
      <AvailableDates
        dateOptions={dateOptions}
        selectedDate={selectedDate}
        customDate={customDate}
        handleSelectDate={handleSelectDate}
        handleSelectCustomDate={handleSelectCustomDate}
      />
      <Separator height={12} transparent />
      <Separator height={1} />
      <Separator height={12} transparent />
      {isTimeSlotAvailable ? (
        <HourlyTimeslots date={activeDate} timeWindows={timeWindows} />
      ) : (
        empty
      )}
    </FlexView>
  );
};

export default AcLedMapping;
